import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, COLLECTIONIMAGEBASEURL, NFTIMAGEBASEURL, ERC721ABI } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData, getBlockChainContract, fetchCommissionRate, isUserSessionActive, handleLogout } from '../helpers/Library';
import Loader from '../commons/Loader';
import axios from "axios";
import { ethers } from "ethers";
import web3 from "web3";



const NftsByUser = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [showStatusCategory, setStatusCategory] = useState(false);
    const [showCurrencyCategory, setCurrencyCategory] = useState(false);
    const [initiateImportNft, setInitiateImportNft] = useState(false);
    const [selectedNftForImport, setSelectedNftForImport] = useState({})
    const [selectedCollectionForImport, setSelectedCollectionForImport] = useState('')
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [nftCollections, setNftCollections] = useState([]);
    const [nfts, setNfts] = useState([]);
    const [ownedNfts, setOwnedNfts] = useState([]);
    const [createdNfts, setCreatedNfts] = useState([]);
    const [onSaleNfts, setOnSaleNfts] = useState([]);
    const [externalNfts, setExternalNfts] = useState([]);
    const [collectionCategories, setCollectionCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [nftTabSelected, setNftTabSelected] = useState('owned');

    const [showCreateColBtn, setShowCreateColBtn] = useState(false);
    const [commissionRate, setCommissionRate] = useState('');
    const [isOwner, setIsOwner] = useState(false);



    const uploadToIPFS = async (file) => {
        const data = new FormData();
        data.append('file', file);

        try {
            const response = await axios.post('https://api.pinata.cloud/pinning/pinFileToIPFS', data, {
                headers: {
                    'pinata_api_key': '6a6acf16ef6baf01fcad',
                    'pinata_secret_api_key': 'c1ffa4ee6d439a780a8a9fc7fd7addefe61605d0d76af84e75ef7ffcac917e71',
                },
            });
            const ipfsHash = response.data.IpfsHash;
            return `ipfs://${ipfsHash}`;
        } catch (error) {
            console.error('Error uploading file to IPFS:', error);
            return null;
        }
    };


    function normalizeIPFSUrlForExternalImport(url) {
        if (!url) return null;

        // Handle ipfs://ipfs/... and ipfs://...
        //console.log('URL..',url);

        if (url.startsWith("ipfs://ipfs/")) {
            return url.replace("ipfs://ipfs/", "ipfs://");
        } else if (url.startsWith("ipfs://")) {
            return url;
        } else if (url.startsWith("http")) {
            return url;  // Already a valid HTTP/HTTPS URL
        }

        //return null; // Invalid or unsupported URL
    }

    const calculateCommission = async () => {
        let commissionRate = await fetchCommissionRate();
        console.log('commission...' + commissionRate);
        setCommissionRate(commissionRate); // Return commission with 6 decimal places for clarity  

    };
    /* method defination for checking contract ownership */
    const checkOwnership = async () => {
        let contract = await getBlockChainContract();
        if (!contract || !getAllSessionData().account) return;
        try {
            const owner = await contract.methods.owner().call();
            console.log('OWNER => ', owner, getAllSessionData().account)
            setIsOwner(getAllSessionData().account.toLowerCase() === owner.toLowerCase());
            calculateCommission();
        } catch (error) {
            console.error('Error checking ownership:', error);
            showToast('error', 'Error checking ownership:', error);
        }
    };


    /* Method defination for updating commission price */
    const updateCommissionRate = async () => {
        let contract = await getBlockChainContract();
        setShowLoader(true)
        if (!contract) {
            showToast('error', 'Contract is not initialized or new commission rate is missing');
            setShowLoader(false)
            return;
        }
        try {
            await contract.methods.setCommissionRate(commissionRate).send({ from: getAllSessionData().account });
            calculateCommission(); // Refresh the commission rate after update
            setShowLoader(false)
        } catch (error) {
            setShowLoader(false)
            calculateCommission();
            showToast('error', 'Error in accepting floor bid:' + error);
            if (error.code === 4001) {
                showToast('error', "Transaction rejected by the user.");
            } else {
                showToast('error', `Unexpected error: ${error.message}`);
            }
        }
    };


    /* Method defination for importing external NFTS */
    const importExternalNFT = async (tokenURI, collectionId, contractAddress, tokenId, name, description) => {
        let isSessionActive = await isUserSessionActive();
        console.log(isSessionActive.isActive);
        if (isSessionActive.isActive) {

            console.log(tokenURI, collectionId, contractAddress, tokenId, name, description);
            setShowLoader(true)
            let imagelink = normalizeIPFSUrlForExternalImport(tokenURI);
            console.log('ImageLinkExternal..', imagelink);
            const metadata = {
                name,
                description,
                image: imagelink,
                collection: collectionId, // Ensure we're passing the collectionId
            };
            const metadataBlob = new Blob([JSON.stringify(metadata)], { type: 'application/json' });
            const metadataFile = new File([metadataBlob], 'metadata.json');
            const metadataIpfsURI = await uploadToIPFS(metadataFile);

            const Web3 = new web3(window.ethereum);

            const contractInstance = new Web3.eth.Contract(ERC721ABI, contractAddress);
            // If not approved, set approval for all tokens in this collection
            const approvalTx = await contractInstance.methods
                .approve('0x850a7C982a8A70927F9D497696a0E63eAcDf6b56', tokenId)
                .send({ from: getAllSessionData().account });

            setShowLoader(false)
            console.log("Approval transaction successful:", approvalTx);
            // alert("Marketplace approved to manage your NFTs!");
            showToast("success", 'Marketplace approved to manage your NFT')
            setTimeout(async () => {
                setShowLoader(true)
                let contract = await getBlockChainContract();
                const listingTx = await contract.methods.importExternalNFT(metadataIpfsURI, collectionId, contractAddress, tokenId).send({ from: getAllSessionData().account });

                console.log("NFT listed successfully:", listingTx);
                setShowLoader(false)
                showToast('success', "NFT is imported successfully!");
                getNftsByUsers();
                setInitiateImportNft(false);


                let payload = { "nftTransaction": { "collectionAddress": collectionId, "tokenId": tokenId, "fromUserUuid": getAllSessionData().uuid, "fromUserAddress": getAllSessionData().account, "nftName": name, "transactionHash": listingTx['transactionHash'] } }

                callAPI('post', NFTAPIBASENAME + '/nft/market/createNft', payload, true).then((res) => {
                    let response = res.data;
                    console.log(response);
                    if (response.error.error_data != 0) {
                        showToast('error', response.error.error_msg)
                    } else {

                    }
                }, (error) => {
                    showHttpError(error)
                })


            }, 1000);
        } else {
            handleLogout()
            setShowLoader(false)
            showToast('error', 'Your session has expired, please login again');
        }
    }





    /* Method defination for fetching external nfts */
    const fetchExternalNFTs = async (walletAddress, chain = "eth") => {
        const apiKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjVlOGU2NDcyLTUyZDItNGQ0YS1hYmM3LTRkODc3OGU3MTY0OSIsIm9yZ0lkIjoiNDM5NDcxIiwidXNlcklkIjoiNDUyMTI4IiwidHlwZSI6IlBST0pFQ1QiLCJ0eXBlSWQiOiIzZDhjMmUwNC01YmM2LTQyMDQtYmNmOS1iOTkxZDFkYjcxYmIiLCJpYXQiOjE3NDM2Nzk1NjQsImV4cCI6NDg5OTQzOTU2NH0.mH9Y6oarw1ZQ8oq_bWCNOCYZsYaUnNk9h5IRvLDrGPM';
        const url = `https://deep-index.moralis.io/api/v2/${walletAddress}/nft?chain=${chain}&limit=100`;

        try {

            const response = await fetch(url, {
                headers: { 'X-API-Key': apiKey, 'Content-Type': 'application/json' }
            });

            const data = await response.json();
            return data; // Array of NFTs


        } catch (error) {
            console.error('Error fetching NFTs:', error.message);
            return [];
        }
    }

    /* Method defination for external nft details */
    const fetchExternalNftDetails = async (contract, nftList) => {

        const now = Math.floor(Date.now() / 1000); // Current timestamp

        return Promise.all(
            nftList.map(async (nft) => {
                try {




                    // Fetch offer details from the contract
                    const offer = await contract.methods.getOffer(nft.id).call();
                    const isOfferExpired = offer[2] > 0 && now > offer[2];

                    // Fetch listing expiration time
                    const expirationTime = await contract.methods.getListingExpiration(nft.id).call();
                    const isExpired = expirationTime > 0 && now > expirationTime;

                    console.log('My NFT Offer:', {
                        offerer: offer[0],
                        offerAmount: offer[1],
                        offerExpiration: offer[2],
                        isExpired: isOfferExpired,
                    });

                    // Return enriched NFT object
                    return {
                        ...nft,

                        offer: {
                            offerer: offer[0],
                            offerAmount: offer[1],
                            offerExpiration: offer[2],
                            isExpired: isOfferExpired,
                        },
                        expirationTime,
                        isExpired,
                        isInvalidated: nft.invalidated,
                    };
                } catch (error) {
                    console.error(`Error fetching metadata for NFT ${nft.id}:`, error);
                    return nft; // Return original NFT if fetching fails
                }
            })
        );

    }






    /* method defination for get colletion list by users */
    let getNftsByUsers = async () => {


        let contract = await getBlockChainContract();

        if (!contract) return;
        const query = ` {
            nfts(where: { or: [{ owner: "${getAllSessionData().account}" }, { creator: "${getAllSessionData().account}" }] }) {
              id
              tokenURI
              price
              owner
              creator
              invalidated
            contractAddress

            }
          }
        `;

        try {
            setShowLoader(true)
            // Fetch NFTs owned by the user from the subgraph
            const response = await fetch('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ query, variables: { owner: getAllSessionData().account } }),
            });
            console.log('Graphql response..', response);
            const { data } = await response.json();
            if(data != undefined){

                // console.log('My NFTs (raw data):', data.nfts); // Debug log
                 const now = Math.floor(Date.now() / 1000);
                 // Process each NFT to fetch additional metadata
                 const fetchNFTs = async (nftList) => {
                     return Promise.all(
                         nftList.map(async (nft) => {
                             try {
                                 // Replace 'ipfs://' with 'https://ipfs.io/ipfs/' for metadata URLs
                                 const metadataUrl = nft.tokenURI.replace('ipfs://', 'https://ipfs.io/ipfs/');
                                 console.log('Fetching metadata from:', metadataUrl); // Log metadata URL
                                 const { data: metadata } = await axios.get(metadataUrl);
                                 const offer = await contract.methods.getOffer(nft.id).call();
                                 const isOfferExpired = offer[2] > 0 && now > offer[2]; // Check expiration
                                 const expirationTime = await contract.methods.getListingExpiration(nft.id).call();
                                 const isExpired = expirationTime > 0 && now > expirationTime;
                                 // Map the NFT data with metadata and price
                                 console.log('My NFTOffer:', {
                                     offerer: offer[0],
                                     offerAmount: offer[1],
                                     offerExpiration: offer[2],
                                     isExpired: isOfferExpired,
                                 });
     
                                 return {
                                     ...nft,
                                     metadata,
                                     offer: {
                                         offerer: offer[0],
                                         offerAmount: offer[1],
                                         offerExpiration: offer[2],
                                         isExpired: isOfferExpired,
                                     },
                                     expirationTime,
                                     isExpired,
                                 };
     
                             } catch (error) {
                                 showToast('error', 'Error fetching metadata:' + error);
                                 return { ...nft, metadata: null };
                             }
                         })
                     );
                 };
     
                 const processedNFTs = await fetchNFTs(data.nfts);
                 console.log('Internal NFTS =>', processedNFTs)
                 //NOTE: Fetch External NFT here
                 const externalNFTsData = await fetchExternalNFTs(getAllSessionData().account);
                 const externalNFTs = externalNFTsData.result.map((nft) => {
                     // Parse the metadata to extract the image
                     const parsedMetadata = nft.metadata ? JSON.parse(nft.metadata) : null;
     
                     // Fix IPFS links if they start with 'ipfs://'
                     const imageLink = parsedMetadata ? parsedMetadata.image : null;
     
     
                     return {
                         id: nft.token_id,
                         contractAddress: nft.token_address.toLowerCase(),
                         owner: nft.owner_of.toLowerCase(),
                         tokenURI: imageLink,  // Corrected to use the image from metadata
                         metadata: parsedMetadata,
                         price: null,
                         invalidated: false,
                         minterAddress: nft.minter_address,
                         status: "import", // Default status
     
                     };
                 });
     
                 //console.log('externalNFTs..',JSON.stringify(externalNFTs,null,2));
                 let processedExternalNFTs = await fetchExternalNftDetails(contract, externalNFTs); // Fetch metadata and offers for external NFTs
                 console.log('processedExternalNFTs..', processedExternalNFTs);
                 const isImportedNFT = (externalNft) =>
                     processedNFTs.some(
                         (internalNft) =>
                             internalNft.contractAddress.toLowerCase() === externalNft.contractAddress.toLowerCase() &&
                             internalNft.id === externalNft.id
                     );
     
                 let updatedExternalNFTs = processedExternalNFTs
                     .filter((nft) => !isImportedNFT(nft))
                     .map((nft) => {
                         nft.status = "import";
                         return nft;
                     });
                 //NOTE: removing import buttons  nfts which are 
     
                 processedExternalNFTs.map((nft) => {
                     console.log(nft.id, isImportedNFT(nft))
                     if (isImportedNFT(nft)) {
                         nft.status = null
                     }
                 });
                 console.log('updatedExternalNFTs => ', updatedExternalNFTs)
                 console.log('All NFTS', processedNFTs)
     
                 // Categorize NFTs into owned, created, and on sale
                 let owned = processedNFTs.filter((nft) => nft.owner != undefined && nft.owner.toLowerCase() === getAllSessionData().account.toString().toLowerCase());
                 // updatedExternalNFTs.forEach((nft, index) => owned.push(nft));
                 let created = processedNFTs.filter((nft) => nft.creator != undefined && nft.creator.toLowerCase() === getAllSessionData().account.toString().toLowerCase());
                 let onSale = processedNFTs.filter(
                     (nft) =>
                         nft.price !== null &&
                         nft.price > 0 &&
                         (nft.owner.toLowerCase() === getAllSessionData().account.toString().toLowerCase())
                 );
                 //NOTE: transfering external NFT to owned NFTs
                 updatedExternalNFTs.map(nft => {
                     owned.push(nft)
                 })
                 setOwnedNfts(owned);
                 setCreatedNfts(created);
                 setOnSaleNfts(onSale);
                 //setExternalNfts(processedExternalNFTs)
     
     
                 console.log('Owned NFTs:', owned);
                 console.log('Created NFTs:', created);
                 console.log('On Sale NFTs:', onSale);
                 // console.log('External NFTs:', externalNFTs);
                 setShowLoader(false)
            }

        } catch (error) {
            setShowLoader(false)
            showToast('error', 'Error loading NFTs' + error);
            console.error('error', error)
        }




    }


    const renderAllCollections = async () => {
        let contract = await getBlockChainContract();

        if (!contract) return;
        try {
            setShowLoader(true)
            const query = `
                {
                  collections {
                    id
                    name
                    description
                    backgroundImage
                    creator
                    volume
                    nfts {
                      id
                      tokenURI
                      price
                      owner
                    }
                  }
                }
              `;

            const response = await axios.post('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', { query });
            const now = Math.floor(Date.now() / 1000);
            const allCollections = response.data.data.collections;
            // Process collections and their NFTs
            const processedCollections = await Promise.all(
                allCollections.map(async (collection) => {
                    // Fetch the floor bid for this collection using the smart contract method
                    const floorBidData = await contract.methods.getFloorBid(collection.id).call();
                    console.log('floorBidData', floorBidData);
                    const isFloorBidExpired = floorBidData.expirationTime > 0 && now > floorBidData.expirationTime;



                    console.log('Combine collection log..', {
                        id: collection.id,
                        name: collection.name,
                        description: collection.description,
                        backgroundImage: collection.backgroundImage,
                        creator: collection.creator,
                        volume: web3.utils.fromWei(collection.volume.toString(), 'ether'),
                        floorBid: {

                            bidder: floorBidData.bidder,
                            bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                            expirationTime: floorBidData.expirationTime,
                            isExpired: isFloorBidExpired,

                        },
                    }
                    );
                    return {
                        id: collection.id,
                        name: collection.name,
                        description: collection.description,
                        backgroundImage: collection.backgroundImage,
                        creator: collection.creator,
                        volume: web3.utils.fromWei(collection.volume.toString(), 'ether'),
                        floorBid: {

                            bidder: floorBidData.bidder,
                            bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                            expirationTime: floorBidData.expirationTime,
                            isExpired: isFloorBidExpired,

                        },
                    };
                })
            );


            console.log('All Collections:', processedCollections);
            let arr = []
            for (let i = 0; i < processedCollections.length; i++) {
                if (processedCollections[i].creator.toLowerCase() == getAllSessionData().account.toLowerCase()) {
                    arr.push(processedCollections[i])
                }
            }
            setNftCollections(arr);
            setShowLoader(false)

        } catch (error) {
            showToast('error', 'Error fetching all collections:' + error);
        }


    }



    /* Method defination for get all collection */
    let getAllCollectionCategory = () => {
        let payload = {}
        setShowLoader(true);
        callAPI('get', NFTAPIBASENAME + '/nft/market/public/getAllCollectionCategory', false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                setCollectionCategories(response.collectionCategories)
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }






    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        /* if (!checkIfUserIsLoggedIn()) {
            showToast('error', 'Please login to continue',);
            setTimeout(() => {
                props.history.push("/");
            }, 1000);
        } else {
            } */
        checkOwnership();
        renderAllCollections();
        getNftsByUsers(props.match.params.id);


    }, []);

    return (
        <Fragment>
            <Header />
            <div className="shop-box-inner">
                {console.log('IsOWNER => ', isOwner)}
                {isOwner && <div className="container" style={{ marginBottom: '20px' }}>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 col-xs-12">
                            <h3>Update Commission Rate</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-sm-12 col-xs-12">
                            <label>Commission Rate (%) : </label>

                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-12 col-xs-12">
                            <input type="text" className="form-control" placeholder="Enter New Commisssion Rate (%)" id="commissionRateField" onChange={(e) => {
                                let value = e.target.value;
                                console.log(value)
                                if (value != '') {
                                    let regex = /^(100|[1-9][0-9]?)$/gm
                                    if (value.match(regex)) {
                                        setCommissionRate(value);
                                    } else {
                                        e.target.value = value.slice(0, -1)
                                    }
                                } else {
                                    setCommissionRate('')
                                }
                            }} value={commissionRate} />

                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-12 col-xs-12">
                            <button className="btn hvr-hover mr-2 " disabled={commissionRate < 1 || commissionRate > 100} onClick={updateCommissionRate}>Update</button>
                        </div>
                    </div>
                </div>}
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 col-xs-12">
                            <h3>My Nfts</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 col-xs-12 shop-content-right">
                            <div className="right-product-box">
                                {/* <div className="product-item-filter row"> */}
                                {/* <div className="col-12 col-sm-8 text-center text-sm-left">
                                        <div className="toolbar-sorter-right"> */}
                                {/*  <span>Sort by </span> */}
                                {/* <select id="basic" className="form-control" data-placeholder="$ USD" style={{ display: 'block' }}>
                                                <option data-display="Select">Sort By</option>
                                                <option value="1">Popularity</option>
                                                <option value="2">High Price → High Price</option>
                                                <option value="3">Low Price → High Price</option>
                                                <option value="4">Best Selling</option>
                                            </select>
                                        </div> */}
                                {/*  <p>Showing all 4 results</p> */}
                                {/* </div> */}
                                {/* <div className="col-12 col-sm-4 text-center text-sm-right"> */}
                                {/*  <ul className="nav nav-tabs ml-auto">
                                    <li>
                                        <a className="nav-link active" href="#grid-view" data-toggle="tab"> <i className="fa fa-th"></i> </a>
                                    </li>
                                    <li>
                                        <a className="nav-link" href="#list-vifew" data-toggle="tab"> <i className="fa fa-list-ul"></i> </a>
                                    </li>
                                </ul> */}
                                {/* {
                                    showCreateColBtn && 
                                    <Link to="/create-collection" className="btn btn-primary">Create Collection</Link>
                                }
                                    </div> */}
                                {/* </div> */}
                                <div className="product-item-filter row">
                                    <div className="col-12 col-sm-8 text-center text-sm-left">
                                        <div className="row">
                                            <div className="col-md-2">
                                                <span className={`${nftTabSelected == 'owned' ? 'profile-status-active' : 'profile-status-inactive'}`} onClick={() => { setNftTabSelected('owned') }}>Owned</span>
                                            </div>
                                            <div className="col-md-2">
                                                <span className={`${nftTabSelected == 'onsale' ? 'profile-status-active' : 'profile-status-inactive'}`} onClick={() => { setNftTabSelected('onsale') }}>On Sale</span>
                                            </div>
                                            <div className="col-md-2">
                                                <span className={`${nftTabSelected == 'created' ? 'profile-status-active' : 'profile-status-inactive'}`} onClick={() => { setNftTabSelected('created') }}>Created</span>
                                            </div>


                                        </div>

                                    </div>
                                </div>
                                <div className="product-categorie-box">
                                    <div className="tab-content">
                                        <div role="tabpanel" className="tab-pane fade show active" id="grid-view">
                                            {nftTabSelected == 'owned' && <div className="row">
                                                {ownedNfts.map((nft) => (
                                                    nft.metadata != null && <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4" key={nft.id}>
                                                        {nft.status != 'import' ? <Link to={`/asset/` + nft.metadata.collection + `/` + nft.id} data-toggle="tooltip" data-placement="right" title="View">
                                                            <div className="products-single fix">
                                                                <div className="box-img-hover">
                                                                    <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                                </div>
                                                                <div className="why-text">
                                                                    <h4>{nft.metadata.name}</h4>
                                                                    <p>Price : {nft.price > 0 && nft.price != null ? web3.utils.fromWei(nft.price.toString(), 'ether') + 'ETH' : 'Not For Sale'}</p>
                                                                    <p style={{ fontSize: '12px' }}>Contract Address : {nft.contractAddress}</p>
                                                                </div>
                                                            </div>
                                                        </Link> : <div>
                                                            <div className="products-single fix">
                                                                <div className="box-img-hover">
                                                                    <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                                </div>
                                                                <div className="why-text">
                                                                    <h4>{nft.metadata.name}</h4>
                                                                    <p>Price : {nft.price > 0 && nft.price != null ? web3.utils.fromWei(nft.price.toString(), 'ether') + 'ETH' : 'Not For Sale'}</p>
                                                                    <p style={{ fontSize: '12px' }}>Contract Address : {nft.contractAddress}</p>
                                                                    <button className="btn hvr-hover mr-2 " data-fancybox-close="" onClick={() => {
                                                                        setSelectedNftForImport(nft)
                                                                        setInitiateImportNft(true)
                                                                    }}>Import NFT</button>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                    </div>
                                                ))}
                                                {
                                                    ownedNfts.length == 0 && (

                                                        <div className="col-md-12 bg-secondary p-5">
                                                            <h1 className='text-white text-center'>No Nft found</h1>
                                                            <div className='text-center mt-3'>
                                                                {/* <a href="./create-nft" className='d-inline-block btn btn-primary'>Create Nft</a> */}

                                                            </div>
                                                        </div>

                                                    )

                                                }


                                            </div>}
                                            {nftTabSelected == 'onsale' && <div className="row">
                                                {onSaleNfts.map((nft) => (
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4" key={nft.id}>
                                                        <Link to={`/asset/` + nft.metadata.collection + `/` + nft.id} data-toggle="tooltip" data-placement="right" title="View">
                                                            <div className="products-single fix">
                                                                <div className="box-img-hover">
                                                                    <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                                </div>
                                                                <div className="why-text">
                                                                    <h4>{nft.metadata.name}</h4>
                                                                    <p>Price : {nft.price > 0 && nft.price != null ? web3.utils.fromWei(nft.price.toString(), 'ether') + 'ETH' : 'Not For Sale'}</p>

                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                ))}
                                                {
                                                    onSaleNfts.length == 0 && (

                                                        <div className="col-md-12 bg-secondary p-5">
                                                            <h1 className='text-white text-center'>No Nft found</h1>
                                                            <div className='text-center mt-3'>
                                                                {/* <a href="./create-nft" className='d-inline-block btn btn-primary'>Create Nft</a> */}

                                                            </div>
                                                        </div>

                                                    )

                                                }


                                            </div>}
                                            {nftTabSelected == 'created' && <div className="row">
                                                {createdNfts.map((nft) => (
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4" key={nft.id}>
                                                        <Link to={`/asset/` + nft.metadata.collection + `/` + nft.id} data-toggle="tooltip" data-placement="right" title="View">
                                                            <div className="products-single fix">
                                                                <div className="box-img-hover">
                                                                    <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                                </div>
                                                                <div className="why-text">
                                                                    <h4>{nft.metadata.name}</h4>
                                                                    <p>Price : {nft.price > 0 && nft.price != null ? web3.utils.fromWei(nft.price.toString(), 'ether') + 'ETH' : 'Not For Sale'}</p>

                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                ))}
                                                {
                                                    createdNfts.length == 0 && (

                                                        <div className="col-md-12 bg-secondary p-5">
                                                            <h1 className='text-white text-center'>No Nft found</h1>
                                                            <div className='text-center mt-3'>
                                                                {/* <a href="./create-nft" className='d-inline-block btn btn-primary'>Create Nft</a> */}

                                                            </div>
                                                        </div>

                                                    )

                                                }


                                            </div>}

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-xl-3 col-lg-3 col-sm-12 col-xs-12 sidebar-shop-left">
                            <div className="product-categori">
                                <div className="search-product">
                                    <form action="#">
                                        <input className="form-control" placeholder="Search here..." type="text" />
                                        <button type="submit"> <i className="fa fa-search"></i> </button>
                                    </form>
                                </div>
                                <div className="filter-sidebar-left">
                                    <div className="title-left">
                                        <h3>Categories</h3>
                                    </div>
                                    <div className="list-group list-group-collapse list-group-sm list-group-tree" id="list-group-men" data-children=".sub-men">
                                        {collectionCategories.map((cat) => (

                                            <div className="list-group-collapse sub-men" key={cat.nftCollectionCategoryId}>
                                                <a onClick={() => { getColletionListByCategory(cat.nftCollectionCategoryId) }} className={`list-group-item list-group-item-action ${cat.nftCollectionCategoryId == selectedCategory ? 'active' : ''}`} href="javascript:void(0)" >{cat.categoryName}
                                                </a>

                                            </div>
                                        ))}
                                       


                                    </div>
                                </div>
                               
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* import nft popup */}
            <Fragment>
                <div className={"modal " + (initiateImportNft ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: initiateImportNft ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Import NFT</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setInitiateImportNft(false); }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ marginBottom: '20px', padding: '0 143px 0 143px' }}>
                                    <div className="col-md-12">
                                        {selectedNftForImport.metadata != undefined && <img src={selectedNftForImport.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt={selectedNftForImport.metadata.name} style={{ height: '100%', width: '100%' }} />}


                                    </div>

                                </div>
                                <div className="row">
                                    {selectedNftForImport.metadata != undefined && <span className="ml-2 col-md-12" style={{ fontSize: '20px', fontWeight: '700', textAlign: 'center' }}>{selectedNftForImport.metadata.name}</span>}
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Collection*</label>
                                        <select className="form-control" id="nftCollection" onChange={(e) => { setSelectedCollectionForImport(e.target.value) }}>
                                            <option value="">Select Collection</option>
                                            {nftCollections.map((collection) => (
                                                <option key={collection.id} value={collection.id.toString()}>{collection.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>




                                <div className="row mt-4 ml-2 mr-2">
                                    <button type="button" className="btn btn-primary col-md-12" disabled={selectedCollectionForImport == ''} onClick={() => {
                                        importExternalNFT(selectedNftForImport.tokenURI, selectedCollectionForImport, selectedNftForImport.contractAddress, selectedNftForImport.id, selectedNftForImport.metadata.name, selectedNftForImport.metadata.description)
                                    }}>Import NFT</button>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>









            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default NftsByUser;